import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ChatInput from "../chat-input";
import MessageItem from "./message-item";
import {
  Avatar,
  IconButton,
  Slide,
  Zoom,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import { useEffect } from "react";
import { setMessages } from "../../../slices/messagesReducer";
import { useAppDispatch } from "../../../store/appHooks";
// import { getAuthUserId } from "../../../utils/auth.util";
import {
  collection,
  deleteDoc,
  doc,
  onSnapshot,
  orderBy,
  query,
  updateDoc,
} from "firebase/firestore";
import { db } from "../../../firebase-config/firebase";
import { getAuthUserId } from "utils/auth.util";
import { stringAvatar } from "utils/avatar.util";
import { MoreVert } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "constants/routes";
import useQuery from "utils/router.util";

const ChatMessages = ({
  convId,
  msgs,
  conversation,
  filterOutNewConversation,
}: {
  convId: string;
  msgs: Array<any>;
  conversation: any;
  filterOutNewConversation: any;
}) => {
  const theme = useTheme();
  const matchesSm = useMediaQuery(theme.breakpoints.down("sm"));
  const matchesXs = useMediaQuery(theme.breakpoints.only("xs"));
  const navigate = useNavigate();
  const loggedInUserId = getAuthUserId();
  const queryD = useQuery();
  const participantId =
    conversation?.participants?.filter(
      (c: string) => c !== loggedInUserId
    )?.[0] ?? 0;

  const participantName =
    convId === "new"
      ? queryD.get("user")
      : conversation?.users?.[participantId] ?? "";

  // const [hasAttachment, setHasAttachment] = useState(false)
  const dispatch = useAppDispatch();

  const messagesCallback = (resp: Array<any>) => {
    dispatch(setMessages(resp));
    var messageBody: any = document.querySelector("#messagingContainer");
    messageBody.scrollTop = messageBody.scrollHeight - messageBody.clientHeight;
    window.document
      .getElementById("messagingContainer")
      ?.scroll({ top: 100000000, behavior: "smooth" });
  };

  useEffect(() => {
    if (!convId) {
      return;
    }

    const buildQuery = query(
      collection(db, "conversations", convId, "messages"),
      orderBy("createdAt", "asc")
    );
    const convMsg = onSnapshot(buildQuery, async (res: any) => {
      if (res.docs.length === 0) {
        return;
      }
      const lastMessage = res.docs[res.docs.length - 1].data(); // get last message
      if (lastMessage?.user?._id !== loggedInUserId) {
        // if last message not sent by current logged in user
        await updateDoc(doc(db, "conversations", convId), {
          lastMessageCount: 0,
        });
      }
      messagesCallback(
        res.size > 0
          ? res.docs.map((d: any) => ({ id: d.id, ...d.data() }))
          : []
      );
    });
    return () => {
      convMsg();
      dispatch(setMessages([]));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [convId]);

  const deleteConversation = () => {
    // deleteDoc(doc(db, "conversations", convId));
  };

  const ChatHeader = () => (
    <Box
      sx={{
        boxShadow: {
          md: "0px 3px 6px 0px #25334B1A",
          lg: "0px 3px 6px 0px #25334B1A",
          xl: "0px 3px 6px 0px #25334B1A",
          sm: "none",
          xs: "none",
        },
        borderBottom: {
          md: "0",
          lg: "0",
          xl: "0",
          sm: "1px solid #E2E2E2",
          xs: "1px solid #E2E2E2",
        },

        background: "#FFF",
        height: {
          md: "96px",
          lg: "96px",
          xl: "96px",
          sm: "80px",
          xs: "80px",
        },
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",

        px: "3%",
      }}
    >
      <Box sx={{ display: "flex", gap: "15px", alignItems: "center" }}>
        <Box
          sx={{
            display: {
              sm: "block",
              xs: "block",
              md: "none",
              lg: "none",
              xl: "none",
            },
          }}
          component="img"
          src="/assets/img/icons/arrow_left.svg"
          onClick={() => navigate(ROUTES.MESSAGES.replace(":id", ""))}
        />

        {conversation?.[`profile_${participantId}`] ? (
          <Avatar
            src={conversation?.[`profile_${participantId}`]}
            style={{ height: "48px", width: "48px" }}
          />
        ) : (
          <Avatar
            {...stringAvatar(participantName)}
            style={{ height: "48px", width: "48px" }}
          />
        )}

        <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: "15px",
              lineHeight: "18px",
              color: "#323232",
            }}
          >
            {participantName}
          </Typography>
          {conversation?.[`typingStatus${participantId}`] === true && (
            <Typography
              sx={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                WebkitLineClamp: "1",
                WebkitBoxOrient: "vertical",

                fontWeight: 400,
                fontSize: "14px",
                lineHeight: "16px",
                color: "#4EA643",
              }}
            >
              Typing...
            </Typography>
          )}
        </Box>
      </Box>
      <IconButton onClick={deleteConversation} sx={{ display: "none" }}>
        <MoreVert />
      </IconButton>
    </Box>
  );
  return (
    <Box
      sx={{
        width: { md: "90%", lg: "90%", sm: "100%", xs: "100%" },
        background: "#F7F7F7",
        // position: "relative",
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      {msgs.length > 0 && !matchesSm && !matchesXs && <ChatHeader />}
      {(matchesSm || matchesXs) && <ChatHeader />}
      <Box sx={{ flex: 1, overflow: "auto" }}>
        {msgs.length > 0 && (
          <Box
            sx={{
              overflow: "auto",
              height: {
                md: "49vh",
                lg: "49vh",
                xl: "49vh",
                sm: "60vh",
                xs: "60vh",
              },
            }}
            className="small-scroll"
            id="messagingContainer"
          >
            {msgs.map((m, i: number) => (
              <MessageItem key={i} msg={m} />
            ))}
          </Box>
        )}

        {msgs.length === 0 && (
          <Box
            sx={{
              // mx: "4%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              // width: "90%",
              // my: "8%",
              height: "100%",
              px: "15px",
            }}
            id="messagingContainer"
          >
            <Box
              component="img"
              src="/assets/img/no-messages.png"
              alt=""
              sx={{
                width: {
                  md: "271px",
                  lg: "271px",
                  xl: "271px",
                  sm: "180px",
                  xs: "180px",
                },
              }}
            />
            <Typography
              sx={{
                color: "#323232",
                fontWeight: 700,
                fontSize: {
                  md: "26px",
                  lg: "26px",
                  xl: "26px",
                  sm: "20px",
                  xs: "20px",
                },
                lineHeight: "31px",
                mt: "20px",
                mb: "10px",
                textAlign: "center",
              }}
            >
              No Messages Available Yet!
            </Typography>
            <Typography
              sx={{
                color: "#A2A2A2",
                fontWeight: 500,
                fontSize: {
                  md: "16px",
                  lg: "16px",
                  xl: "16px",
                  sm: "14px",
                  xs: "14px",
                },
                lineHeight: "24px",
                mb: "15px",
                textAlign: "center",
              }}
            >
              It appears there are no messages in your inbox at the moment. Feel
              free{" "}
              <Box
                component="br"
                sx={{
                  display: {
                    md: "block",
                    lg: "block",
                    xl: "block",
                    sm: "none",
                    xs: "none",
                  },
                }}
              />
              to explore other features while you wait for new messages to
              arrive.
            </Typography>
          </Box>
        )}
      </Box>
      {convId && (
        <Box
          sx={{
            background: "#FFFFFF",
            // position: "absolute",
            height: {
              md: "84px",
              lg: "84px",
              xl: "84px",
              sm: "70px",
              xs: "70px",
            },
            width: "100%",
            // bottom: 0,

            borderTop: "1px solid #E9E9E9",
          }}
        >
          <ChatInput
            convId={convId}
            setHasAttachment={() => {}}
            conversation={conversation}
            filterOutNewConversation={filterOutNewConversation}
          />
        </Box>
      )}
    </Box>
  );
};

export default ChatMessages;
